import React from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  Alert,
  CardHeader
} from 'reactstrap'


const propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.object)
}

const UserAddressList = ({ addresses }) => (

  <Card>
    <CardHeader>
      <span className=' text-uppercase  font-weight-bolder'>
        { 'Addresses' }
      </span>
    </CardHeader>
    <Card
      body
    >
      <div style={{
        maxHeight : '300px',
        overflowY : 'auto'
      }}
      >
        {
          addresses.length === 0
            ?
            <Alert color='info'><i className='fas fa-info-circle mr-2'/>Alamat kamu kosong, silahkan buat alamat baru.</Alert>
            :
            addresses.map((address, index) => (
              <UserAddressCard
                key={ `address-card-${index}` }
                address={ address }
              />

            ))
        }
      </div>
    </Card>
  </Card>


)



const userAddressCardProps = {
  address: PropTypes.shape({
    recipient_name : PropTypes.string,
    telephone      : PropTypes.string,
    street_address : PropTypes.string,
    district       : PropTypes.string,
    sub_district   : PropTypes.string,
    city           : PropTypes.string,
    province       : PropTypes.string,
    postal_code    : PropTypes.string
  }
  )
}


const UserAddressCard = ({ address }) => (

  <Card
    body
    className={ 'small mb-3' }
    style={{
      boxShadow: 'rgb(49 53 59 / 12%) 0px 1px 6px 0px'
    }}
  >

    <div className='d-flex justify-content-between mb-3'>
      <h5 className='text-capitalize text-truncate' >
        <strong>
          { address.recipient_name }
        </strong>
      </h5>
      <h5 className='text-center'>
        { address.telephone }
      </h5>
    </div>
    <div className='text-capitalize'>
      { address.street_address }<br/>
      { address.sub_district }{ ', ' }{ address.district }<br/>
      { address.city }{ ', ' }{ address.province } <br/>
      { address.postal_code }<br />
    </div>

  </Card>
)

UserAddressCard.propTypes = userAddressCardProps

UserAddressList.propTypes = propTypes

export default UserAddressList
